import React from 'react';
import { Zap, Users } from 'lucide-react';
export function CountdownBanner() {
  return <div className="bg-gradient-to-r from-red-950/90 via-red-900/90 to-red-950/90 border-y border-gold/20 py-5 px-4 relative overflow-hidden" data-id="element-43">
      <div className="max-w-4xl mx-auto relative z-10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-8 text-center sm:text-left" data-id="element-44">
        <div className="flex items-center gap-2 text-gold-light font-semibold text-base sm:text-lg" data-id="element-45">
          <Zap className="w-5 h-5" data-id="element-46" />
          <span data-id="element-47">Precio de lanzamiento por tiempo limitado</span>
        </div>
        <span className="hidden sm:inline text-cream-muted/30" data-id="element-48">|</span>
        <div className="flex items-center gap-2 text-cream-muted text-sm sm:text-base" data-id="element-49">
          <Users className="w-4 h-4 text-gold/60" data-id="element-50" />
          <span data-id="element-51">
            Disponible solo para las primeras{' '}
            <strong className="text-cream" data-id="element-52">50 alumnas</strong>
          </span>
        </div>
      </div>
    </div>;
}